'use client';

import {useLocale} from '@epic-mw/i18n';
import {useAccountVerifyLogin} from '../auth';
import {useCallback} from 'react';
import {useTalon} from '../captcha';
import {ErrorCode} from '@/types/error.types';
import {dispatchSnackbar} from '../browser';

/**
 * 1. Verify Account logged in
 * 2. Verify Captcha Solved
 * 3. ??
 */
export const useAccessCheck = () => {
	const locale = useLocale();
	const {initCaptcha, talonState} = useTalon();
	const {verifyAuthenticated, accountLoading} = useAccountVerifyLogin(locale);

	return {
		isLoading: accountLoading || talonState.inProgress,
		check: useCallback(
			(config: {
				action: <T extends object>(result: T) => void;
				redirectIfFailUrl: string;
			}): void => {
				// verifyAuthenticated redirects user to login.
				const authenticated = verifyAuthenticated({redirectUrl: config.redirectIfFailUrl});

				if (!authenticated) {
					return; // user will be logging out
				}

				// If we're not connected to the internet, throw offline error.
				if (!navigator.onLine) {
					dispatchSnackbar(ErrorCode.OFFLINE, 'critical');
					return;
				}

				return initCaptcha((solveToken) => config.action({solveToken}));
			},
			[verifyAuthenticated, initCaptcha]
		)
	};
};
